/* eslint-disable */

function BodyBuilder(isXfinity) {
    let externalDiv;
    let bodyData;
    let bodyContainer;
    let bodyBodyContainer;
    let bodyLeftColumn;
    let bodyRightColumn;
    let footerLinkContainer;
    let leftColumnFooterLeftColumnFooter;
    let leftColumnFooter;
    let bodyRightColumnBodyTextContainer;
    let landingPageUrl;
    const page = document.body.classList.value;

    this.setExternalDiv = function (externalDivI) {
        externalDiv = externalDivI;
    };

    this.setData = function (bodyDataI) {
        bodyData = bodyDataI;
    };

    this.drawComponent = function () {
        construct();
    };

    function checkPage() {
        return document.querySelector('.page-simple-quote-form') === null ? true : false;
    }

    function construct() {
        bodyContainer = externalDiv.jsAppend('div').jsAddClass('bodyContainer');

        constructTitle();
        constructBody();
        constructLinks();
    }

    function constructTitle() {
        let bodyTitleContainer = bodyContainer.jsAppend('div').jsAddClass('bodyTitleContainer');

        for (let elementObject of bodyData.title) {
            bodyTitleContainer
                .jsAppend(elementObject.element)
                .jsAddClass(elementObject.className)
                .jsText(elementObject.text);
        }
    }

    function constructBody() {
        bodyBodyContainer = bodyContainer.jsAppend('div').jsAddClass('bodyBodyContainer');

        constructBodyLeftColumn();
        constructBodyRightColumn();
    }

    function constructBodyLeftColumn() {
        bodyLeftColumn = bodyBodyContainer.jsAppend('div').jsAddClass('bodyLeftColumn');

        constructLeftColumnIntro();
        constructLeftColumnBody();
        if (bodyData.leftColumn.belowTool) constructLeftColumnBodyBelowTool();
        if (checkPage()) constructLeftColumnButton();
        constructLeftColumnFooter();
    }

    function constructLeftColumnIntro() {
        let leftColumnIntro = bodyLeftColumn.jsAppend('div').jsAddClass('leftColumnIntro');
        constructLeftColumn(leftColumnIntro, bodyData.leftColumn.intro);
    }

    function constructLeftColumnBody() {
        let leftColumnBody = bodyLeftColumn.jsAppend('div').jsAddClass('leftColumnBody');
        constructLeftColumn(leftColumnBody, bodyData.leftColumn.body);
    }

    function constructLeftColumnBodyBelowTool() {
        let leftColumnBodyBelowTool = bodyLeftColumn.jsAppend('div').jsAddClass('leftColumnBodyBelowTool');
        constructLeftColumn(leftColumnBodyBelowTool, bodyData.leftColumn.belowTool);
    }

    function constructLeftColumn(container, data) {
        for (let elementObject of data) {
            let leftColumnElement = container.jsAppend(elementObject.element).jsAddClass(elementObject.className);

            if (elementObject.text) {
                leftColumnElement.innerHTML = elementObject.text;
            }

            if (elementObject.attr) {
                leftColumnElement.jsAttr(elementObject.attr);
            }
        }
    }

    function constructLeftColumnButton() {
        let button = bodyLeftColumn
            .jsAppend('div')
            .jsAddClass('bodyLeftColumnButton')
            .jsAddEventListener('click', function () {
                const url = checkPage() ? `${landingPageUrl}&utm_content=bottom-get-quote` : landingPageUrl;
                window.open(url, '_blank');
            });

        const buttonText = document.body.classList.contains('smart-sensor-outbrain')
            ? 'GET INSTANT QUOTE'
            : 'GET A QUOTE';

        button.jsAppend('p').jsText(buttonText);
    }

    function constructLeftColumnFooter() {
        leftColumnFooter = bodyLeftColumn.jsAppend('div').jsAddClass('leftColumnFooter');

        constructFooterLeftColumn();
        constructFooterRightColumn();
        constructFooterFooterRow();
    }

    function constructFooterLeftColumn() {
        let leftFooterData = bodyData.leftColumnFooter.left;
        let leftColumnFooterLeftColumn = leftColumnFooter.jsAppend('div').jsAddClass('leftColumnFooterLeftColumn');
        let container = leftColumnFooterLeftColumn.jsAppend('div').jsAddClass('leftColumnFooterLeftColumnTop');

        for (let footerObject of leftFooterData) {
            if (footerObject.attr) {
                appendLeftColumnFooterLink(leftColumnFooterLeftColumn, footerObject);
            } else {
                if (leftColumnFooterLeftColumnFooter) {
                    container = leftColumnFooterLeftColumnFooter;
                }
                let footerElement = container.jsAppend(footerObject.element).jsAddClass(footerObject.className);

                if (footerObject.text) {
                    footerElement.innerHTML = footerObject.text;
                }
            }
        }
    }

    function appendLeftColumnFooterLink(leftColumnFooterLeftColumn, footerObject) {
        if (!leftColumnFooterLeftColumnFooter) {
            leftColumnFooterLeftColumnFooter = leftColumnFooterLeftColumn
                .jsAppend('div')
                .jsAddClass('leftColumnFooterLeftColumnFooter');

            footerLinkContainer = leftColumnFooterLeftColumnFooter
                .jsAppend('div')
                .jsAddClass('leftColumnFooterLinkContainer');
        }

        footerLinkContainer
            .jsAppend(footerObject.element)
            .jsAddClass(footerObject.className)
            .jsAttr(footerObject.attr)
            .jsText(footerObject.text);
    }

    function constructFooterRightColumn() {
        let leftColumnFooterRightColumn = leftColumnFooter.jsAppend('div').jsAddClass('leftColumnFooterRightColumn');

        let rightFooterData = bodyData.leftColumnFooter.right;

        for (let footerObject of rightFooterData) {
            let footerElement = leftColumnFooterRightColumn
                .jsAppend(footerObject.element)
                .jsAddClass(footerObject.className);

            if (footerObject.text) {
                footerElement.innerHTML = footerObject.text;
            }
        }
    }

    function constructFooterFooterRow() {
        externalDiv.jsAppend('img').jsAddClass('footerFooterRow').jsAttr({
            src: 'taboola/resources/City_Illustration_Copy@2x.svg'
        });
    }

    function constructBodyRightColumn() {
        bodyRightColumn = bodyBodyContainer.jsAppend('div').jsAddClass('bodyRightColumn');

        // for pages not using address standardization
        if (checkPage()) constructRightColumnBody();
    }

    function constructRightColumnBody() {
        let bodyRightColumnBody = bodyRightColumn.jsAppend('div').jsAddClass('bodyRightColumnBody');

        bodyRightColumnBody.jsAppend('div').jsAddClass('bodyRightColumnIcon');

        bodyRightColumnBodyTextContainer = bodyRightColumnBody
            .jsAppend('div')
            .jsAddClass('bodyRightColumnBodyTextContainer');

        for (let rightColumnElementData of bodyData.rightColumn) {
            let rightColumnElement = bodyRightColumnBodyTextContainer
                .jsAppend(rightColumnElementData.element)
                .jsAddClass(rightColumnElementData.className);

            if (rightColumnElementData.element === 'div') {
                rightColumnElement.jsAddEventListener('click', function () {
                    if (rightColumnElementData.className === 'rightColumnSecondButton') {
                        const addressInput = document.getElementsByClassName('rightColumnFirstButton')[0];
                        const addressInputValue = addressInput.value;
                        const prefilledAddress = {};

                        if (addressInputValue) {
                            prefilledAddress.street = addressInputValue;
                            const url = checkPage()
                                ? `${landingPageUrl}&utm_content=callout-cta-get-quote&prefilledAddress=${JSON.stringify(
                                      prefilledAddress
                                  )}`
                                : `${landingPageUrl}&prefilledAddress=${JSON.stringify(prefilledAddress)}`;
                            window.open(url, '_blank');
                        }
                    } else {
                        const url = checkPage()
                            ? `${landingPageUrl}&utm_content=callout-cta-get-quote`
                            : landingPageUrl;
                        window.open(url, '_blank');
                    }
                });
                rightColumnElement.jsAppend('p').jsText(rightColumnElementData.text);
            } else if (rightColumnElementData.element === 'input') {
                rightColumnElement.placeholder = rightColumnElementData.placeholderText;
            } else {
                rightColumnElement.innerHTML = rightColumnElementData.text;
            }
        }
    }

    function constructLinks() {
        const params = checkPage()
            ? '?utm_medium=referral-link&utm_source=' + bodyData.source + '&utm_campaign=' + bodyData.campaign
            : '?utm_campaign=home-insurance-guide';
        const xfinityUTMParams = window.location.search || params;

        landingPageUrl = isXfinity ? 'https://myhippo.com/xfinity' + xfinityUTMParams : 'https://myhippo.com';
    }
}
